import { Component, OnInit } from '@angular/core';
import {CustomProductsService} from '../custom-products.service';
import { NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CustomPortsContentComponent } from '../custom-ports-content/custom-ports-content.component';
import { CustomProductTypeContentComponent } from '../custom-product-type-content/custom-product-type-content.component';
import { CustomProductsBrowseAllContentComponent } from '../custom-products-browse-all-content/custom-products-browse-all-content.component';
import { I18nModule } from '@spartacus/core';
@Component({
    selector: 'app-custom-products-content',
    templateUrl: './custom-products-content.component.html',
    styleUrls: ['./custom-products-content.component.scss'],
    imports: [NgIf, FormsModule, CustomPortsContentComponent, CustomProductTypeContentComponent, CustomProductsBrowseAllContentComponent, I18nModule]
})
export class CustomProductsContentComponent implements OnInit {
  list = false;
  grid = true;
  selectedSort: any = 'relevance';
  gridSrc = '/images/grid-view-orange.svg';
  listSrc =  '/images/list-view.svg';
  activeTab = 'port';

  constructor(private customProductService: CustomProductsService ) { }

  viewList(): any {
    this.listSrc =  '/images/list-view-orange.svg';
    this.gridSrc = '/images/grid-view.svg';
    this.list = true;
    this.grid = false;
  }

  selectChangeHandler(event: any): void {
    this.selectedSort = event.target.value;
    this.customProductService.getsortChange(this.selectedSort);
  }

  viewGrid(): void {
    this.gridSrc = '/images/grid-view-orange.svg';
    this.listSrc =  '/images/list-view.svg';
    this.grid = true;
    this.list = false;
  }

  ngOnInit(): void {
  }

  refreshCarousel(data): void{
    this.activeTab = data;
    this.customProductService.refreshFunction(false);
  }
  refreshCarouselProduct(data): void{
    this.activeTab = data;
    this.customProductService.refreshFunctionProduct(false);
  }
  refreshCarouselAll(data): void{
    this.activeTab = data;
    this.customProductService.refreshFunctionAll(false);
  }
}
